import { CheckOutlined, LinkOutlined } from "@ant-design/icons";
import { fmtTimeHM } from "../../extensions/utils";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { isMobile } from '../../extensions/design';
import { Card, Space, Typography } from "antd";
import "./records-item.css"

const { Title, Text } = Typography;

/** Запись в таблице записей */
const RecordsItem = ({item, left, top, width, height, onClick, onVisit, onChangeSelect, selected, 
  onUpdate, timeColWidth, userColWidth, headerRowHeight, hourRowHeight, company, todayUsers, vid, updateRecordOnServer, data }) => {
  
  const [isHovered, setIsHovered] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  // Определение цвета фона по приоритетам
  const getBackgroundByStatus = (record) => {
    
    const clientRecords = record.cnts.filter(i => i.objectVid === 1);
    const now = dayjs();
    const isExpired = record.dateTimeFinish ? now.isAfter(dayjs(record.dateTimeFinish)) : false;

    const allClientsDidNotCome = clientRecords.length > 0 && clientRecords.every(i => i.used === false);
    const allClientsCameAndLeft = clientRecords.length > 0 && clientRecords.every(i => i.used === true && i.visitFinish);
    const someCame = clientRecords.some(i => i.used === true);
    const someClientsDidNotCome = clientRecords.some(i => i.used === false) && someCame;
    const someoneNotLeft = clientRecords.some(i => i.used === true && !i.visitFinish);

    if (record.deleted) return "gray";
    if (allClientsDidNotCome && isExpired) return "red";
    if (allClientsCameAndLeft) return "#bfbfbf";
    if (someClientsDidNotCome || someoneNotLeft) return "#2f6f00";
    return "#f18408";
  };


if (isMobile) {
  return (
    <div className="records-cards-scroll">
      {data.map(item => {
        var start = dayjs(item.start).format("HH:mm");
        var finish = dayjs(item.finish).format("HH:mm");
        if (start === 'Invalid Date' || finish === 'Invalid Date') {
          start = item.start ? item.start.slice(0, 5) : ''
          finish = item.finish ? item.finish.slice(0, 5) : ''
        }
        const services = (item.cnts || []).filter(cnt => cnt.objectVid === 2);
        const servicesText = services.length > 0 ? ` (${services.map(s => s.objectName).join(", ")})` : "";
        const clients = item.cnts.filter(i => i.objectVid === 1);

        return (
          <Card
            key={item.id}
            className="record-card"
            style={{ borderLeft: `4px solid ${getBackgroundByStatus(item)}` }}
            onClick={() => onClick && onClick(item.id)}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Text strong>{start} - {finish} {servicesText}</Text>
              <Space size={4}>
                {item.maxClients > 0 && (
                  <Text strong>{`${clients.length} из ${item.maxClients}`}</Text>
                )}
                {item.linkId && (
                  <LinkOutlined style={{ color: '#fff', fontSize: 14, background: 'rgba(0,0,0,0.45)', borderRadius: 4, padding: '0 3px' }} title={`Цепочка #${item.linkId}`} />
                )}
              </Space>
            </div>
            <Text>{item.roomName}</Text><br/>
            <Text>Сотрудник: {item.userName}</Text><br/>
            {clients.length > 0 && (
              <>
                <Text strong>Клиенты:</Text>
                <Text style={{ marginLeft: 6 }}>
                  {clients.map(c => c.objectName).join(", ")}
                </Text>
              </>
            )}
          </Card>
        );
      })}
    </div>
  );
}

  const clientCnts = item.cnts.filter(i => i.objectVid === 1);
  const productCnts = item.cnts.filter(i => i.objectVid === 2);

  const onVisitClick = e => {
    e.stopPropagation();
    onVisit(item);
  }

  const className = "records-item" + (item.deleted ? " records-item-deleted" : "");

  let backgroundByStatus = getBackgroundByStatus(item);
  const getImageClient = vid => vid === 0 ? "/images/physicalClient.svg" : "/images/organisation.svg";

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const checked = selected.find(i => i === item.id)

  // Обработчики drag and drop
  const handleDragStart = (e) => {
    setIsDragging(true);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', JSON.stringify({
      id: item.id,
      start: item.start.format('HH:mm'),
      finish: item.finish.format('HH:mm'),
      userId: item.userId,
      roomId: item.roomId
    }));
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e) => {
    e.preventDefault();
    try {
      const dragData = JSON.parse(e.dataTransfer.getData('text/plain'));
      if (dragData.id === item.id) return; // Нельзя перетащить на себя
      
      // Определяем новую позицию на основе координат drop
      const rect = e.currentTarget.getBoundingClientRect();
      const dropX = e.clientX - rect.left;
      const dropY = e.clientY - rect.top;
      
      // Вычисляем новый столбец (сотрудник/зал)
      const newColumnIndex = Math.floor((dropX - timeColWidth) / userColWidth);
      const newUser = todayUsers[newColumnIndex];
      
      // Вычисляем новое время с шагом 15 минут
      const relativeY = dropY - headerRowHeight;
      const minutesFromStart = (relativeY / hourRowHeight) * 60;
      const roundedMinutes = Math.round(minutesFromStart / 15) * 15;
      const newStart = dayjs().startOf('day').add((company?.hourStart ?? 0) * 60 + roundedMinutes, 'minute');
      
      // Вычисляем новое время окончания (сохраняем длительность)
      const duration = dayjs(dragData.finish, 'HH:mm').diff(dayjs(dragData.start, 'HH:mm'), 'minute');
      const newFinish = newStart.add(duration, 'minute');
      
      // Вызываем функцию обновления
      updateRecordOnServer && updateRecordOnServer(dragData.id, {
        newUserId: vid === 0 ? newUser?.id : dragData.userId,
        newRoomId: vid === 1 ? newUser?.id : dragData.roomId,
        newStart: newStart,
        newFinish: newFinish
      });
    } catch (error) {
      console.error('Error handling drop:', error);
    }
  };

  const itemStyle = {
    left, 
    top, 
    width: isHovered ? 'auto' : width, // при наведении расширяемся по ширине текста
    height, 
    minHeight: height,
    maxHeight: height, // базовая высота для плавного увеличения через max-height
    maxWidth: isHovered ? 'max-content' : width,
    zIndex: isHovered ? 100 : 10,
    whiteSpace: isHovered ? 'nowrap' : 'normal', // при наведении не переносим, чтобы расти по ширине
    minWidth: isHovered ? width : undefined,
    ...(backgroundByStatus ? { backgroundColor: backgroundByStatus } : {})
  };

  // Если высота слишком мала и первая строка будет обрезана — не показываем текст
  const hideText = !isHovered && height < 16;
  
  return<div 
    className={className + (isDragging ? " records-item-dragging" : "")} 
    style={itemStyle} 
    onClick={() => onClick(item.id)}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    draggable={true}
    onDragStart={handleDragStart}
    onDragEnd={handleDragEnd}
    onDragOver={handleDragOver}
    onDrop={handleDrop}
    key={item.id}
  >
    {!isHovered && (
      <div style={{ position: 'absolute', top: 2, left: 4, zIndex: 20, fontWeight: 700, color: 'white' }}>&gt;</div>
    )}
    {!hideText && (
      <div className="record-item-time" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>{fmtTimeHM(item.start)} - {fmtTimeHM(item.finish)}</div>
        <Space size={4}>
          {item.maxClients > 0 && (
            <div style={{ fontWeight: 700, marginLeft: 8 }}>{`${clientCnts.length} из ${item.maxClients}`}</div>
          )}
          {item.linkId && (
            <LinkOutlined style={{ color: '#fff', fontSize: 14, background: 'rgba(0,0,0,0.45)', borderRadius: 4, padding: '0 3px' }} title={`Цепочка #${item.linkId}`} />
          )}
        </Space>
      </div>
    )}
    {!hideText && item.roomName && <div className="record-item-room">{item.roomName}</div>}
    {!hideText && clientCnts.map(i => (<div className="record-item-line" key={i.id}>
      {i.used ? <CheckOutlined style={{color: "#2f6f00", fontSize: 12}}/> : <img src={getImageClient(i.clientVid)} alt="client" style={{width: 12}}/>}
      {i.objectName}</div>))}
    {!hideText && productCnts.map(i => (<div className="record-item-line"><img src="/images/dot.svg" alt="client" style={{width: 8}}/>{i.objectName}</div>))}
    {!hideText && <div>{item.comment}</div>}
    {item.cnts.filter(i => !i.used && i.objectVid === 1).length ? <div className="records-item-button" onClick={onVisitClick}>Визит</div> : null}
    {(isHovered || checked) && (
      <input 
        type="checkbox" 
        onClick={(e) => { onChangeSelect(item.id); e.stopPropagation(); }}
        checked={checked}
        style={{ position: 'absolute', top: '2px', left: '2px', zIndex: 30, }}
      />
    )}
  </div>
}

export default RecordsItem;